function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 0V22H1V0H23ZM17.743 9.98199C15.897 9.98199 14.715 11.163 14.715 12.714C14.715 14.398 15.705 15.195 17.196 15.83L17.713 16.052C18.658 16.465 19.22 16.716 19.22 17.425C19.22 18.015 18.673 18.444 17.817 18.444C16.797 18.444 16.222 17.912 15.779 17.189L14.095 18.163C14.701 19.36 15.941 20.275 17.861 20.275C19.825 20.275 21.287 19.256 21.287 17.395C21.287 15.668 20.297 14.9 18.54 14.147L18.023 13.925C17.137 13.541 16.753 13.29 16.753 12.67C16.753 12.168 17.137 11.784 17.743 11.784C18.333 11.784 18.717 12.034 19.072 12.67L20.682 11.636C20.002 10.44 19.057 9.98199 17.742 9.98199H17.743ZM12.973 10.1H10.905V17.13C10.905 18.163 10.477 18.429 9.797 18.429C9.088 18.429 8.793 17.942 8.468 17.366L6.785 18.385C7.272 19.418 8.232 20.275 9.885 20.275C11.717 20.275 12.972 19.3 12.972 17.159V10.1H12.973Z",
  fill: "#ABAEC7",
  fillOpacity: 0.6
});

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.d842c6f8.svg";
export { ForwardRef as ReactComponent };